import { create } from 'zustand'

interface UploadProgressState {
  uploadProgress: number
  uploadFilename: string | null
  statusText: string
  isUploading: boolean
  setUploadProgress: (progress: number, statusText?: string, filename?: string) => void
  setIsUploading: (uploading: boolean) => void
  reset: () => void
}

export const useUploadProgressStore = create<UploadProgressState>((set) => ({
  uploadProgress: 0,
  uploadFilename: null,
  statusText: '',
  isUploading: false,
  setUploadProgress: (progress, statusText, filename) =>
    set((state) => ({
      uploadProgress: progress,
      ...(statusText !== undefined ? { statusText } : {}),
      ...(filename ? { uploadFilename: filename } : {}),
      isUploading: state.isUploading,
    })),
  setIsUploading: (uploading) =>
    set({ isUploading: uploading, ...(uploading ? {} : { uploadProgress: 0 }) }),
  reset: () => set({ uploadProgress: 0, uploadFilename: null, statusText: '', isUploading: false }),
}))
